import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, tap } from "rxjs/operators";
import { RankingEndpointsService } from "src/app/api/services";
import * as fromActions from './branchchampions.actions';
import { of } from "rxjs";
import { RankListResponseWrapper } from "src/app/api/models";

@Injectable()
export class BranchChampionsEffects {

    loadBranchChampions$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.loadMany),
            mergeMap(({ month, nameSpace }) => {
                return this.api.getChampionList({ month: month, nameSpace: nameSpace }).pipe(
                    map((branchChampions: RankListResponseWrapper) => {
                        return fromActions.loadManySuccess({ items: [branchChampions] })
                    }),
                    catchError(error =>
                        of(fromActions.loadManyFail({ error })),
                    ),
                )
            }),
        ),
    );

    constructor(
        private actions$: Actions,
        private api: RankingEndpointsService,
    ) { }

}